export default __webpack_public_path__ + "static/student_answer_feedback-75bc4eaf9d7b5fd17c9299a13493c074.mp4";